import { CompareProducts, useCompare } from '@iheartjane/menu';

interface CompareMenuItemProps {
  onToggle: () => void;
  productId: number;
  productName: string;
}

/** Provider-connected Compare row for the product card's overflow menu. */
export const CompareMenuItem = ({
  onToggle,
  productId,
  productName,
}: CompareMenuItemProps) => {
  const { isAtMax, isSelected } = useCompare();
  const selected = isSelected(productId);

  return (
    <CompareProducts.MenuItem
      disabled={isAtMax && !selected}
      isSelected={selected}
      onToggle={onToggle}
      productName={productName}
    />
  );
};
